<form class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Create a new password</h1>
    <p class="text-base opacity-80 mt-2">
      Please create a new password for your account.
    </p>

    <div class="mt-4">
      <div class="form-group mb-3">
        <label for="password">Password</label>
        <div class="relative">
          <input
            autocapitalize="off"
            id="password"
            #password
            placeholder="&#x2022; &#x2022; &#x2022; &#x2022; &#x2022;"
            type="password"
          />
          <button
            type="button"
            class="absolute inset-y-0 right-4 flex items-center"
            (click)="
              password.type == 'password'
                ? (password.type = 'text')
                : (password.type = 'password')
            "
          >
            <span
              [class]="
                password.type == 'password' ? 'mdi--eye' : 'mdi--eye-off'
              "
              class="iconify mdi--eye text-2xl text-[#A6A6A6]"
            ></span>
          </button>
        </div>
      </div>
      <div class="form-group mb-3">
        <label for="password-repeat">Confirm Password</label>
        <div class="relative">
          <input
            autocapitalize="off"
            id="password-repeat"
            #passwordRepeat
            placeholder="&#x2022; &#x2022; &#x2022; &#x2022; &#x2022;"
            type="password"
          />
          <button
            type="button"
            class="absolute inset-y-0 right-4 flex items-center"
            (click)="
              passwordRepeat.type == 'password'
                ? (passwordRepeat.type = 'text')
                : (passwordRepeat.type = 'password')
            "
          >
            <span
              [class]="
                passwordRepeat.type == 'password' ? 'mdi--eye' : 'mdi--eye-off'
              "
              class="iconify mdi--eye text-2xl text-[#A6A6A6]"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full mb-5">
    <app-button class="font-bold">Confirm new password and access</app-button>
  </div>
</form>
